import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

const disableRealtime = import.meta.env.VITE_DISABLE_REALTIME === "1";

const appVersion =
  import.meta.env.VITE_APP_VERSION ||
  import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA?.slice(0, 12) ||
  "dev";

const clientSignature = `farmly-web/${appVersion};surface=spa`;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      "x-client-info": clientSignature,
    },
  },
  realtime: disableRealtime
    ? { params: { eventsPerSecond: 0 } } // "no-op-ish"
    : undefined,
});
